import Vue from 'vue'
import App from './App.vue'
import router from './router'
import API from './api'
import wx from './utils/WXUntil'
import number from './utils/number'
import '@/styles/base.less'
import 'lib-flexible/flexible'

import {getCookie, setCookie} from "@/utils/auth"; // 路由权限
let main_url = getCookie('main_url');
if (!main_url) {
  setCookie('main_url', window.location.href)
}

Vue.config.productionTip = false

Vue.prototype.$API = API
Vue.prototype.$wx = wx
Vue.prototype.$number = number

import './permission'

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
